import { GetSowillSectors } from '@/domain/usecases'
import { SowillSectorResult } from '@/domain/models'
import { RemoteGetSowillSectors } from '@/data/usecases/events'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeGetSowillSectorsFactory = (): GetSowillSectors => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<SowillSectorResult | string>()

  return new RemoteGetSowillSectors(url, httpClient)
}
